import { DynamicRowConfig, FieldType, OptionType } from "@components/DynamicForm/DynamicForm";
import { RegisterOptions } from "react-hook-form";
import { getCentralisedAirlineImagesDrillDownData } from "~/Modules/Centralized/Forms/AirlineImages/AirlineImages.drilldown";
import { getCentralisedBannerDrillDownData } from "~/Modules/Centralized/Forms/Banner/Banner.drilldown";
import { getCentralizedFAQsDrillDownData } from "~/Modules/Centralized/Forms/FAQs/FAQs.drilldown";
import { getCentralizedModulesDrillDownData } from "~/Modules/Centralized/Forms/Modules/CentralizedModules.drilldown";
import { getMyAirportsPromotionsDrillDownData } from "~/Modules/Centralized/Forms/MyAiportsPromotions/MyAirportsPromotion.drilldowndata";
import { getPrivacyPolicyDrillDownData } from "~/Modules/Centralized/Forms/PrivacyPolicy/PrivacyPolicy.drilldown";
import { getCentralisedPromotionsDrillDownData } from "~/Modules/Centralized/Forms/Promotions/Promotions.drilldown";
import { getCentralizedShopDineDrillDownData } from "~/Modules/Centralized/Forms/ShopAndDine/ShopAndDine.drilldowndata";
import { getCentralizedTravellersInfoDrillDownData } from "~/Modules/Centralized/Forms/TravellersInfo/drilldownDataForCentralizedTravellersInfo";
import { getBusinessOpportunityDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/BusinessOppurtunities/drilldowndataForBusinessOpp";
import { getCorporateIntegrityDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/CorporateIntegrity/drilldowndataforCorporateIntegrity";
import { getOurBrandDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/CorporateProfile/OurBrand/drilldownDataForOurBrand";
import { getOurPoliciesNextPageDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/CorporateProfile/OurPolicies/OurPolicies.NextPage.drilldown";
import { getHomepageBannerDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/Homepage/HomepageBanner/HomepageBanner.drilldownData";
import { getPublicationsDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/Homepage/Publications/Publications.drilldownData";
import { getspotlightLargeCardsDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/Homepage/SpotLight/LargeCards/LargeCards.drilldownData";
import { getspotlightSmallCardsDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/Homepage/SpotLight/SmallCards/SmallCards.drilldownData";
import { getMainNavigationDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/MainNavigation/drilldownDataForMainNavigation";
import { getMediaCentreDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/MediaCentre/drilldownDataForMediaCentre";
import { getNavigationDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/Navigation/drilldownDataForNavigation";
import { getOrganisationDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/Organization/drilldownDataForOrganisation";
import { getAgenciesDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/StakeHolders/Agencies/agencies.Drilldowndata";
import { getSubsidiariesHeadingDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/Subsidiaries/SubsidiariesPageHeading/Subsidiaries.drilldownData";
import { subsidiariesDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/Subsidiaries/drilldowndataForSubsidiaries";
import { SubsidiaryKey } from "~/Modules/ECMS/CORPORATE/Forms/Subsidiaries/types";
import { getOurMilestonesDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/TrainingAcademy/MilestonesNew/Milestones.drilldown";
import { getOurClientsDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/TrainingAcademy/OurClients/OurClients.drilldown";
import { getAdvertisementDrillDownData } from "~/Modules/ECMS/ERAMAN/Forms/Advertisement/drilldownDataForAdvertisement";
import { getConfigurationDrillDownData } from "~/Modules/ECMS/ERAMAN/Forms/Configuration/drilldownDataForConfiguration";
import { getEramanContentDrilldownData } from "~/Modules/ECMS/ERAMAN/Forms/Contents/drilldownData.EramanContents";
import { getFooterDrilldownData } from "~/Modules/ECMS/ERAMAN/Forms/Footer/drilldownData.Footer";
import { getFormsSubmissionsDrillDownData } from "~/Modules/ECMS/ERAMAN/Forms/FormsSubmissions/drilldownDataForFormsSubmissions";
import { getHeaderDrilldownData } from "~/Modules/ECMS/ERAMAN/Forms/Header/drilldownData.Header";
import { getMembersDrillDownData } from "~/Modules/ECMS/ERAMAN/Forms/Members/drilldownDataForMembers";
import { getPagesAboutEramanDrillDownData } from "~/Modules/ECMS/ERAMAN/Forms/Pages/AboutEraman/drilldownDataForAboutEraman";
import { getPagesContactCentreDrillDownData } from "~/Modules/ECMS/ERAMAN/Forms/Pages/ContactCentre/drilldownDataForContactCentre";
import { getPagesEramanPrivilegeCardDrillDownData } from "~/Modules/ECMS/ERAMAN/Forms/Pages/EramanPrivilegeCard/drilldownDataForEramanPrivilegeCard";
import { getPagesTravellersInfoDrillDownData } from "~/Modules/ECMS/ERAMAN/Forms/Pages/TravellersInfo/drilldownDataForTravellersInfo";
import { getProductManagementDrillDownData } from "~/Modules/ECMS/ERAMAN/Forms/ProductManagement/ProductManagement.drilldownData";
import { getProductReviewsDrillDownData } from "~/Modules/ECMS/ERAMAN/Forms/ProductReviews/drilldownDataForProductReviews";
import { getStoreLocationsDrillDownData } from "~/Modules/ECMS/ERAMAN/Forms/StoreLocations/StoreLocations.drilldowndata";
import { announcementDrilldownData } from "~/Modules/ECMS/MAGP/Announcement/annoucement-drilldown";
import { getAnnouncementsDrillDownData } from "~/Modules/ECMS/MAGP/Forms/Announcements/Announcements.drilldown";
import { getContactDirectoryDrillDownData } from "~/Modules/ECMS/MAGP/Forms/ContractDirectory/ContractDirectory.drilldown";
import { getFaqDrillDownData } from "~/Modules/ECMS/MAGP/Forms/FAQ/drilldownDataforFAQ";
import { getLoginDrillDownData } from "~/Modules/ECMS/MAGP/Forms/Login/drilldownDataForLogin";
import { getManualDrillDownData } from "~/Modules/ECMS/MAGP/Forms/Manual/drilldownDataForManual";
import { getOthersDrillDownData } from "~/Modules/ECMS/MAGP/Forms/Others/drilldownDataForOthers";
import { getPopupDrillDownData } from "~/Modules/ECMS/MAGP/Forms/Popup/drilldownDataForPopup";
import { getProfileDrillDownData } from "~/Modules/ECMS/MAGP/Forms/Profile/drilldownDataForProfile";
import { getGalleryDrillDownData } from "~/Modules/ECMS/MAGP/Gallery/Gallery.drilldown";
import { getFlightInfoDrillDownData } from "~/Modules/ECMS/PASSENGER/FlightInfo/Flightinfo.drilldowndata";
import { getHeaderpassDrillDownData } from "~/Modules/ECMS/PASSENGER/Header/HeaderPassanger.drilldownData";
import { getHelpDrillDownData } from "~/Modules/ECMS/PASSENGER/Help/Help.drilldowndata";
import { getAirportLocationDrillDownData } from "~/Modules/ECMS/PASSENGER/Maps/Maps.drilldowndata";
import { getShopDineDrillDownData } from "~/Modules/ECMS/PASSENGER/ShopAndDine/ShopAndDine.drilldowndata";
import { getFooterDrillDownData } from "~/Modules/ECMS/PASSENGER/footer/Footer.drilldownData";
import getHomepageDrillDownData from "~/Modules/ECMS/PASSENGER/homepage/Homepagemanagment.drilldownData";
import { getMobileDrillDownData } from "~/Modules/ECMS/PASSENGER/mobileapp/MobileApp.drilldownData";

export type ModuleConfig =
  | "cameraAccess"
  | "languagePopUp"
  | "purchaseLoginPopUp"
  | "logoutPopUp"
  | "VMSPopUp"
  | "faq"
  | "loginPopUp"
  | "userProfileSettings"
  | "purchaseSuccess"
  | "welcomePageForCalendar"
  | "purchaseQR"
  | "loginPage"
  | "announcement"
  | "brandingGuidelinesPageContent"
  | "managementIntegrityMessage"
  | "antiBriberyCorruption"
  | "whistleblowingProgram"
  | "whistleblowingPolicy"
  | "reportingConcern"
  | "ourBrand"
  | "ourProfile"
  | "ourStory"
  | "ourBusiness"
  | SubsidiaryKey
  | "airlineServices"
  | "codeOfEthicsForMalaysiaAirportsHoldingsBerhad"
  | "conditionsOfUseForMalaysiaAirportsHoldingsBerhad"
  | "energyPolicyForMalaysiaAirportsHoldingsBerhad"
  | "environmentalManagementPolicyForMalaysiaAirportsHoldingsBerhad"
  | "fraudPolicyForMalaysiaAirportsHoldingsBerhad"
  | "giftPolicyForMalaysiaAirportsHoldingsBerhad"
  | "noSmokingPolicyForMalaysiaAirportsHoldingsBerhad"
  | "policyInWorkplaceForMalaysiaAirportsHoldingsBerhad"
  | "privacyNoticeForMalaysiaAirportsHoldingsBerhad"
  | "privacyNoticeForShareholdersForMalaysiaAirportsHoldingsBerhad"
  | "procurementManualForMalaysiaAirportsHoldingsBerhad"
  | "riskManagementPolicyStatementForMalaysiaAirportsHoldingsBerhad"
  | "occupationalHealthAndSafetyPolicyForMalaysiaAirportsHoldingsBerhad"
  | "sexualHarassmentPolicyForMalaysiaAirportsHoldingsBerhad"
  | "stopWorkPolicyForMalaysiaAirportsHoldingsBerhad"
  | "antiBriberyAndCorruptionPolicyStatementForMalaysiaAirportsHoldingsBerhad"
  | "sustainabilityPolicyForMalaysiaAirportsHoldingsBerhad"
  | "termsOfConditionsForMalaysiaAirportsHoldingsBerhad"
  | "codeOfEthicsForSubsidiaries"
  | "conditionsOfUseForSubsidiaries"
  | "airportConsultancy"
  | "klInternationalAirport"
  | "kotaKinabaluInternationalAirport"
  | "kuchingInternationalAirport"
  | "langkawiInternationalAirport"
  | "penangInternationalAirport"
  | "melakaAirport"
  | "sultanAbdulAzizShahAirport"
  | "sultanAbdulHalimAirportAlorSetar"
  | "sultanAhmadShahAirportKuantan"
  | "sultanAzlanShahAirportIpoh"
  | "sultanIsmailPetraAirportKotaBharu"
  | "sultanMahmudAirportKualaTerengganu"
  | "bintuluAirport"
  | "limbangAirport"
  | "miriAirport"
  | "muluAirport"
  | "mukahAirport"
  | "sibuAirport"
  | "labuanAirport"
  | "lahadDatuAirport"
  | "sandakanAirport"
  | "tawauAirport"
  | "pangkorStolport"
  | "redangStolport"
  | "tiomanStolport"
  | "bakelalanStolport"
  | "barioStolport"
  | "belagaStolport"
  | "kapitStolport"
  | "lawasStolport"
  | "longAkahStolport"
  | "longBangaStolport"
  | "longLellangStolport"
  | "longSemadoStolport"
  | "longSeridanStolport"
  | "marudiStolport"
  | "kudatStolport"
  | "longPasiaStolport"
  | "sempornaStolport"
  | "istanbulSabihaGokcenAirport"
  | "manualWelcomePage"
  | "procurementPlanning"
  // | "privacyPolicyTabOne"
  // | "privacyPolicyTabTwo"
  | "myAirportsPrivacyPolicy";

export interface ModuleFields {
  fieldName: string;
  fieldValue: any;
  className: string;
  parseField?: string;
  type:
    | "number"
    | "text"
    | "textarea"
    | "image"
    | "checkbox"
    | "content"
    | "video"
    | "date"
    | "dateTime"
    | "pdf"
    | "select"
    | "dynamicRow"
    | "mobile"
    | "dateFormat";
  name: string;
  formType: FieldType;
  label: string;
  placeholder: string;

  validation?: RegisterOptions;
  options?: OptionType[];
  loadOptions?: (selectedModule?: any, currentAirport?: any) => Promise<OptionType[]>;
  editable?: boolean;
  hidden?: boolean;
  usedFileType?: string;
  note?: string;
  futureDateRestriction?: boolean;
  dynamicFormType?: string;
  autoFillFromYoutube?: boolean;
  autoYoutubeDuration?: boolean;
  rowConfig?: DynamicRowConfig[];
  showField?: (formValues: any) => boolean;
  imageDimension?: {
    width: number;
    height: number;
  };
  openUpload?: (fieldName: string, setValue: (name: string, value: string) => void) => void;
  uploadTrigger?: boolean;
  disabledPreviousDateTime?: boolean;
}

export const drilldownData: { [key in ModuleConfig]: ModuleFields[] } = {
  cameraAccess: getPopupDrillDownData.cameraAccess,
  loginPopUp: getPopupDrillDownData.loginPopUp,
  languagePopUp: getPopupDrillDownData.languagePopUp,
  purchaseLoginPopUp: getPopupDrillDownData.purchaseLoginPopUp,
  logoutPopUp: getPopupDrillDownData.logoutPopUp,
  VMSPopUp: getPopupDrillDownData.VMSPopUp,
  faq: getFaqDrillDownData.faq,
  userProfileSettings: getProfileDrillDownData.userProfileSettings,
  purchaseSuccess: getProfileDrillDownData.purchaseSuccess,
  purchaseQR: getProfileDrillDownData.purchaseQR,
  welcomePageForCalendar: getOthersDrillDownData.welcomePageForCalendar,
  mobileLoginPage: getLoginDrillDownData.mobileLoginPage,
  tender: announcementDrilldownData,
  brandingGuidelinesPageContent: getMediaCentreDrillDownData.brandingGuidelinesPageContent,
  brandingGuidelinesNextPage: getMediaCentreDrillDownData.brandingGuidelinesNextPage,
  brandingGuidelinesPageHeading: getMediaCentreDrillDownData.brandingGuidelinesPageHeading,
  newsPageHeading: getMediaCentreDrillDownData.newsPageHeading,
  latestNewsNextPage: getMediaCentreDrillDownData.latestNewsNextPage,
  archivesNewsNextPage: getMediaCentreDrillDownData.archivesNewsNextPage,
  ourBrand: getOurBrandDrillDownData.ourBrand,
  parentHeader: getNavigationDrillDownData.parentHeader,
  childHeader: getNavigationDrillDownData.childHeader,
  grandChildHeader: getNavigationDrillDownData.grandChildHeader,
  // ourProfile: getOurProfileDrillDownData.ourProfile,
  // ourStory: getOurProfileDrillDownData.ourStory,
  // ourBusiness: getOurProfileDrillDownData.ourBusiness,
  // codeOfEthicsForMalaysiaAirportsHoldingsBerhad:
  //   getOurPoliciesDrillDownData.codeOfEthicsForMalaysiaAirportsHoldingsBerhad,
  // conditionsOfUseForMalaysiaAirportsHoldingsBerhad:
  //   getOurPoliciesDrillDownData.conditionsOfUseForMalaysiaAirportsHoldingsBerhad,
  // energyPolicyForMalaysiaAirportsHoldingsBerhad:
  //   getOurPoliciesDrillDownData.energyPolicyForMalaysiaAirportsHoldingsBerhad,
  // environmentalManagementPolicyForMalaysiaAirportsHoldingsBerhad:
  //   getOurPoliciesDrillDownData.environmentalManagementPolicyForMalaysiaAirportsHoldingsBerhad,
  // fraudPolicyForMalaysiaAirportsHoldingsBerhad:
  //   getOurPoliciesDrillDownData.fraudPolicyForMalaysiaAirportsHoldingsBerhad,
  // giftPolicyForMalaysiaAirportsHoldingsBerhad: getOurPoliciesDrillDownData.giftPolicyForMalaysiaAirportsHoldingsBerhad,
  // noSmokingPolicyForMalaysiaAirportsHoldingsBerhad:
  //   getOurPoliciesDrillDownData.noSmokingPolicyForMalaysiaAirportsHoldingsBerhad,
  // policyInWorkplaceForMalaysiaAirportsHoldingsBerhad:
  //   getOurPoliciesDrillDownData.policyInWorkplaceForMalaysiaAirportsHoldingsBerhad,
  // privacyNoticeForMalaysiaAirportsHoldingsBerhad:
  //   getOurPoliciesDrillDownData.privacyNoticeForMalaysiaAirportsHoldingsBerhad,
  // privacyNoticeForShareholdersForMalaysiaAirportsHoldingsBerhad:
  //   getOurPoliciesDrillDownData.privacyNoticeForShareholdersForMalaysiaAirportsHoldingsBerhad,
  // procurementManualForMalaysiaAirportsHoldingsBerhad:
  //   getOurPoliciesDrillDownData.procurementManualForMalaysiaAirportsHoldingsBerhad,
  // riskManagementPolicyStatementForMalaysiaAirportsHoldingsBerhad:
  //   getOurPoliciesDrillDownData.riskManagementPolicyStatementForMalaysiaAirportsHoldingsBerhad,
  // occupationalHealthAndSafetyPolicyForMalaysiaAirportsHoldingsBerhad:
  //   getOurPoliciesDrillDownData.occupationalHealthAndSafetyPolicyForMalaysiaAirportsHoldingsBerhad,
  // sexualHarassmentPolicyForMalaysiaAirportsHoldingsBerhad:
  //   getOurPoliciesDrillDownData.sexualHarassmentPolicyForMalaysiaAirportsHoldingsBerhad,
  // stopWorkPolicyForMalaysiaAirportsHoldingsBerhad:
  //   getOurPoliciesDrillDownData.stopWorkPolicyForMalaysiaAirportsHoldingsBerhad,
  // antiBriberyAndCorruptionPolicyStatementForMalaysiaAirportsHoldingsBerhad:
  //   getOurPoliciesDrillDownData.antiBriberyAndCorruptionPolicyStatementForMalaysiaAirportsHoldingsBerhad,
  // sustainabilityPolicyForMalaysiaAirportsHoldingsBerhad:
  //   getOurPoliciesDrillDownData.sustainabilityPolicyForMalaysiaAirportsHoldingsBerhad,
  // termsOfConditionsForMalaysiaAirportsHoldingsBerhad:
  //   getOurPoliciesDrillDownData.termsOfConditionsForMalaysiaAirportsHoldingsBerhad,
  // codeOfEthicsForSubsidiaries: getOurPoliciesDrillDownData.codeOfEthicsForSubsidiaries,
  // conditionsOfUseForSubsidiaries: getOurPoliciesDrillDownData.conditionsOfUseForSubsidiaries,
  managementIntegrityMessagePageContent: getCorporateIntegrityDrillDownData.managementIntegrityMessagePageContent,
  managementIntegrityMessagePageHeading: getCorporateIntegrityDrillDownData.managementIntegrityMessagePageHeading,
  antiBriberyCorruptionPageContent: getCorporateIntegrityDrillDownData.antiBriberyCorruptionPageContent,
  antiBriberyCorruptionPageHeading: getCorporateIntegrityDrillDownData.antiBriberyCorruptionPageHeading,
  whistleblowingProgramPageContent: getCorporateIntegrityDrillDownData.whistleblowingProgramPageContent,
  whistleblowingProgramPageHeading: getCorporateIntegrityDrillDownData.whistleblowingProgramPageHeading,
  whistleblowingPolicyPageContent: getCorporateIntegrityDrillDownData.whistleblowingPolicyPageContent,
  whistleblowingPolicyPageHeading: getCorporateIntegrityDrillDownData.whistleblowingPolicyPageHeading,
  reportingConcernPageContent: getCorporateIntegrityDrillDownData.reportingConcernPageContent,
  reportingConcernPageHeading: getCorporateIntegrityDrillDownData.reportingConcernPageHeading,
  managementIntegrityMessageNextPage: getCorporateIntegrityDrillDownData.managementIntegrityMessageNextPage,
  antiBriberyCorruptionNextPage: getCorporateIntegrityDrillDownData.antiBriberyCorruptionNextPage,
  whistleblowingProgramNextPage: getCorporateIntegrityDrillDownData.whistleblowingProgramNextPage,
  whistleblowingPolicyNextPage: getCorporateIntegrityDrillDownData.whistleblowingPolicyNextPage,
  reportingConcernNextPage: getCorporateIntegrityDrillDownData.reportingConcernNextPage,
  malaysiaAirportsSepangSdnBhd: subsidiariesDrillDownData("malaysiaAirportsSepangSdnBhd"),
  malaysiaAirportsSdnBhd: subsidiariesDrillDownData("malaysiaAirportsSdnBhd"),
  malaysiaAirportsNiagaSdnBhd: subsidiariesDrillDownData("malaysiaAirportsNiagaSdnBhd"),
  malaysiaAirportsConsultancyServicesSdnBhd: subsidiariesDrillDownData("malaysiaAirportsConsultancyServicesSdnBhd"),
  klAirportsHotelSdnBhd: subsidiariesDrillDownData("klAirportsHotelSdnBhd"),
  mabAgricultureHorticultureSdnBhd: subsidiariesDrillDownData("mabAgricultureHorticultureSdnBhd"),
  urusanTeknologiWawasanSdnBhd: subsidiariesDrillDownData("urusanTeknologiWawasanSdnBhd"),
  kliaAeropolisSdnBhd: subsidiariesDrillDownData("kliaAeropolisSdnBhd"),
  isgSgc: subsidiariesDrillDownData("isgSgc"),
  malaysiaAirportsPropertiesSdnBhd: subsidiariesDrillDownData("malaysiaAirportsPropertiesSdnBhd"),
  nextPageForSubsidiaries: subsidiariesDrillDownData("nextPageForSubsidiaries"),
  airlineServices: [],
  airportConsultancy: getBusinessOpportunityDrillDownData.airportConsultancy,
  airportConsultancyPageHeading: getBusinessOpportunityDrillDownData.airportConsultancyPageHeading,
  airportConsultancyNextPage: getBusinessOpportunityDrillDownData.airportConsultancyNextPage,
  // klInternationalAirport: drilldownDataCorporatePolicies.klInternationalAirport,
  // kotaKinabaluInternationalAirport: drilldownDataCorporatePolicies.kotaKinabaluInternationalAirport,
  // kuchingInternationalAirport: drilldownDataCorporatePolicies.kuchingInternationalAirport,
  // langkawiInternationalAirport: drilldownDataCorporatePolicies.langkawiInternationalAirport,
  // penangInternationalAirport: drilldownDataCorporatePolicies.penangInternationalAirport,
  // melakaAirport: drilldownDataCorporatePolicies.melakaAirport,
  // sultanAbdulAzizShahAirport: drilldownDataCorporatePolicies.sultanAbdulAzizShahAirport,
  // sultanAbdulHalimAirportAlorSetar: drilldownDataCorporatePolicies.sultanAbdulHalimAirportAlorSetar,
  // sultanAhmadShahAirportKuantan: drilldownDataCorporatePolicies.sultanAhmadShahAirportKuantan,
  // sultanAzlanShahAirportIpoh: drilldownDataCorporatePolicies.sultanAzlanShahAirportIpoh,
  // sultanIsmailPetraAirportKotaBharu: drilldownDataCorporatePolicies.sultanIsmailPetraAirportKotaBharu,
  // sultanMahmudAirportKualaTerengganu: drilldownDataCorporatePolicies.sultanMahmudAirportKualaTerengganu,
  // bintuluAirport: drilldownDataCorporatePolicies.bintuluAirport,
  // limbangAirport: drilldownDataCorporatePolicies.limbangAirport,
  // miriAirport: drilldownDataCorporatePolicies.miriAirport,
  // muluAirport: drilldownDataCorporatePolicies.muluAirport,
  // mukahAirport: drilldownDataCorporatePolicies.mukahAirport,
  // sibuAirport: drilldownDataCorporatePolicies.sibuAirport,
  // labuanAirport: drilldownDataCorporatePolicies.labuanAirport,
  // lahadDatuAirport: drilldownDataCorporatePolicies.lahadDatuAirport,
  // sandakanAirport: drilldownDataCorporatePolicies.sandakanAirport,
  // tawauAirport: drilldownDataCorporatePolicies.tawauAirport,
  // pangkorStolport: drilldownDataCorporatePolicies.pangkorStolport,
  // redangStolport: drilldownDataCorporatePolicies.redangStolport,
  // tiomanStolport: drilldownDataCorporatePolicies.tiomanStolport,
  // bakelalanStolport: drilldownDataCorporatePolicies.bakelalanStolport,
  // barioStolport: drilldownDataCorporatePolicies.barioStolport,
  // belagaStolport: drilldownDataCorporatePolicies.belagaStolport,
  // kapitStolport: drilldownDataCorporatePolicies.kapitStolport,
  // lawasStolport: drilldownDataCorporatePolicies.lawasStolport,
  // longAkahStolport: drilldownDataCorporatePolicies.longAkahStolport,
  // longBangaStolport: drilldownDataCorporatePolicies.longBangaStolport,
  // longLellangStolport: drilldownDataCorporatePolicies.longLellangStolport,
  // longSemadoStolport: drilldownDataCorporatePolicies.longSemadoStolport,
  // longSeridanStolport: drilldownDataCorporatePolicies.longSeridanStolport,
  // marudiStolport: drilldownDataCorporatePolicies.marudiStolport,
  // kudatStolport: drilldownDataCorporatePolicies.kudatStolport,
  // longPasiaStolport: drilldownDataCorporatePolicies.longPasiaStolport,
  // sempornaStolport: drilldownDataCorporatePolicies.sempornaStolport,
  // istanbulSabihaGokcenAirport: drilldownDataCorporatePolicies.istanbulSabihaGokcenAirport,
  manualWelcomePage: getManualDrillDownData.manualWelcomePage,
  procurementPlanning: getManualDrillDownData.procurementPlanning,
  procurementPlanningProcessFlowChart: getManualDrillDownData.procurementPlanningProcessFlowChart,
  businessCaseOverview: getManualDrillDownData.procurementPlanning,
  businessCasePolicies: getManualDrillDownData.procurementPlanning,
  businessCaseProcessFlowChart: getManualDrillDownData.procurementPlanning,
  annualProcurementPlanningOverview: getManualDrillDownData.procurementPlanning,
  annualProcurementPlanningPolicies: getManualDrillDownData.procurementPlanning,
  annualProcurementPlanningProcessFlowChart: getManualDrillDownData.procurementPlanning,
  strategyPaperOverview: getManualDrillDownData.procurementPlanning,
  strategyPaperPolicies: getManualDrillDownData.procurementPlanning,
  strategyPaperProcessFlowChartDirectAppointment: getManualDrillDownData.procurementPlanning,
  strategyPaperProcessFlowChartOpenTenderInvitationToBid: getManualDrillDownData.procurementPlanning,
  requisition: getManualDrillDownData.requisition,
  requisitionProcessFlowChart: getManualDrillDownData.requisitionProcessFlowChart,
  purchaseRequisitionOverview: getManualDrillDownData.requisition,
  purchaseRequisitionPolicies: getManualDrillDownData.requisition,
  purchaseRequisitionProcessFlowChart: getManualDrillDownData.requisition,
  processingofPurchaseRequisitionOverview: getManualDrillDownData.requisition,
  processingofPurchaseRequisitionPolicies: getManualDrillDownData.requisition,
  processingofPurchaseRequisitionProcessFlowChart: getManualDrillDownData.requisition,
  contractAdministration: getManualDrillDownData.contractAdministration,
  contractAdministrationProcessFlowChart: getManualDrillDownData.contractAdministrationProcessFlowChart,
  contractManagementImplementationOverview: getManualDrillDownData.contractAdministration,
  contractManagementImplementationPolicies: getManualDrillDownData.contractAdministration,
  contractManagementImplementationProcessFlowChart: getManualDrillDownData.contractAdministration,
  contractRenewalOverview: getManualDrillDownData.contractAdministration,
  contractRenewalPolicies: getManualDrillDownData.contractAdministration,
  contractRenewalProcessFlowChart: getManualDrillDownData.contractAdministration,
  contractTerminationOverview: getManualDrillDownData.contractAdministration,
  contractTerminationPolicies: getManualDrillDownData.contractAdministration,
  contractTerminationProcessFlowChart: getManualDrillDownData.contractAdministration,
  contractCloseoutOverview: getManualDrillDownData.contractAdministration,
  contractCloseoutPolicies: getManualDrillDownData.contractAdministration,
  contractCloseoutProcessFlowChart: getManualDrillDownData.contractAdministration,
  vendorManagement: getManualDrillDownData.vendorManagement,
  vendorManagementProcessFlowChart: getManualDrillDownData.vendorManagementProcessFlowChart,
  vendorRegistrationOverview: getManualDrillDownData.vendorManagement,
  vendorRegistrationPolicies: getManualDrillDownData.vendorManagement,
  vendorRegistrationProcessFlowChartRenewal: getManualDrillDownData.vendorManagement,
  vendorRegistrationProcessFlowChartNewRegistration: getManualDrillDownData.vendorManagement,
  potentialVendorScreeningOverview: getManualDrillDownData.vendorManagement,
  potentialVendorScreeningPolicies: getManualDrillDownData.vendorManagement,
  potentialVendorScreeningProcessFlowChart: getManualDrillDownData.vendorManagement,
  vendorPerformanceManagementOverview: getManualDrillDownData.vendorManagement,
  vendorPerformanceManagementPolicies: getManualDrillDownData.vendorManagement,
  vendorPerformanceManagementProcessFlowChartUnscheduled: getManualDrillDownData.vendorManagement,
  vendorPerformanceManagementProcessFlowChartSchedule: getManualDrillDownData.vendorManagement,
  sourcing: getManualDrillDownData.sourcing,
  sourcingProcessFlowChart: getManualDrillDownData.sourcingProcessFlowChart,
  tenderManagementOverview: getManualDrillDownData.sourcing,
  tenderManagementPolicies: getManualDrillDownData.sourcing,
  tenderManagementProcessFlowChart: getManualDrillDownData.sourcing,
  tenderAdministrationOverview: getManualDrillDownData.sourcing,
  tenderAdministrationPolicies: getManualDrillDownData.sourcing,
  tenderAdministrationProcessFlowChartaboveRM5000000: getManualDrillDownData.sourcing,
  tenderAdministrationProcessFlowChartbelowRM5000000: getManualDrillDownData.sourcing,
  tenderEvaluationOverview: getManualDrillDownData.sourcing,
  tenderEvaluationPolicies: getManualDrillDownData.sourcing,
  tenderEvaluationProcessFlowChart: getManualDrillDownData.sourcing,
  abortofTenderOverview: getManualDrillDownData.sourcing,
  abortofTenderPolicies: getManualDrillDownData.sourcing,
  abortofTenderProcessFlowChart: getManualDrillDownData.sourcing,
  clarificationNegotiationpriortoAwardOverview: getManualDrillDownData.sourcing,
  clarificationNegotiationpriortoAwardPolicies: getManualDrillDownData.sourcing,
  clarificationNegotiationpriortoAwardProcessFlowChartNegotiation: getManualDrillDownData.sourcing,
  clarificationNegotiationpriortoAwardProcessFlowChartClarificationPriortoAward: getManualDrillDownData.sourcing,
  introduction: getManualDrillDownData.introduction,
  preface: getManualDrillDownData.introduction,
  procurementCodesOfEthics: getManualDrillDownData.introduction,
  generalProvision: getManualDrillDownData.introduction,
  termsAndConditions: getManualDrillDownData.introduction,
  processSymbols: getManualDrillDownData.introduction,
  mahbProcurementValueChain: getManualDrillDownData.introduction,
  prefaceAndObjectivesOfProcurementManual: getManualDrillDownData.introduction,
  nextPageOurPolicies: getOurPoliciesNextPageDrillDownData.nextPageOurPolicies,
  aboutUs: getPagesAboutEramanDrillDownData.aboutUs,
  timeline: getPagesAboutEramanDrillDownData.timeline,
  welcomeNote: getPagesAboutEramanDrillDownData.welcomeNote,
  awardsList: getPagesAboutEramanDrillDownData.awardsList,
  awardsContent: getPagesAboutEramanDrillDownData.awardsContent,
  news: getPagesAboutEramanDrillDownData.news,
  homePagePopup: getPagesAboutEramanDrillDownData.homePagePopup,
  contactUs: getPagesAboutEramanDrillDownData.contactUs,
  contactDetails: getPagesAboutEramanDrillDownData.contactDetails,
  formDetails: getPagesAboutEramanDrillDownData.formDetails,
  storeLocations: getStoreLocationsDrillDownData.storeLocations,
  careersContent: getPagesAboutEramanDrillDownData.careersContent,
  TermsAndConditions: getPagesEramanPrivilegeCardDrillDownData.TermsAndConditions,
  Faqs: getPagesEramanPrivilegeCardDrillDownData.Faqs,
  jobOpportunities: getPagesAboutEramanDrillDownData.jobOpportunities,
  faqs: getPagesEramanPrivilegeCardDrillDownData.faqs,
  baggageGuide: getPagesTravellersInfoDrillDownData.baggageGuide,
  singleCabinLuggagePolicy: getPagesTravellersInfoDrillDownData.singleCabinLuggagePolicy,
  guidelinesForCheckedinLuggage: getPagesTravellersInfoDrillDownData.guidelinesForCheckedinLuggage,
  lagsAndRestrictedItems: getPagesTravellersInfoDrillDownData.lagsAndRestrictedItems,
  restrictedItems: getPagesTravellersInfoDrillDownData.restrictedItems,
  lags: getPagesTravellersInfoDrillDownData.lags,
  dutyFreeBuyingGuide: getPagesTravellersInfoDrillDownData.dutyFreeBuyingGuide,
  footerContactInfo: getPagesContactCentreDrillDownData.footerContactInfo,
  privacyPolicy: getPagesContactCentreDrillDownData.privacyPolicy,
  enquiries: getFormsSubmissionsDrillDownData.enquiries,
  enquiriesEmailTemplate: getFormsSubmissionsDrillDownData.enquiriesEmailTemplate,
  users: getConfigurationDrillDownData.users,
  edmMailer: getConfigurationDrillDownData.edmMailer,
  registeredUsers: getMembersDrillDownData.registeredUsers,
  productReviews: getProductReviewsDrillDownData.productReviews,
  epcApplications: getFormsSubmissionsDrillDownData.epcApplications,
  notificationSettings: getConfigurationDrillDownData.notificationSettings,
  productBrand: getProductManagementDrillDownData.productBrand,
  products: getProductManagementDrillDownData.products,
  subCategories: getProductManagementDrillDownData.subCategories,
  categories: getProductManagementDrillDownData.categories,
  fAndBContent: getProductManagementDrillDownData.fAndBContent,
  fAndBBrands: getProductManagementDrillDownData.fAndBBrands,
  fAndBOutlet: getProductManagementDrillDownData.fAndBOutlet,
  fAndBCategory: getProductManagementDrillDownData.fAndBCategory,
  eXpress: getProductManagementDrillDownData.eXpress,
  airport: getStoreLocationsDrillDownData.airport,
  level: getStoreLocationsDrillDownData.level,
  outlet: getStoreLocationsDrillDownData.outlet,
  promotions: getConfigurationDrillDownData.promotions,
  newsLetter: getConfigurationDrillDownData.newsLetter,
  airlineIncentivesPageContent: getBusinessOpportunityDrillDownData.airlineIncentivesPageContent,
  airlineIncentivesNextPage: getBusinessOpportunityDrillDownData.airlineIncentivesNextPage,
  airlineIncentivesPageHeading: getBusinessOpportunityDrillDownData.airlineIncentivesPageHeading,
  airlineServicesFacilitiesNextPage: getBusinessOpportunityDrillDownData.airlineServicesFacilitiesNextPage,
  overseasInvestments: getBusinessOpportunityDrillDownData.overseasInvestments,
  airportOperationsAndAirportSystems: getBusinessOpportunityDrillDownData.airportOperationsAndAirportSystems,
  airportDevelopment: getBusinessOpportunityDrillDownData.airportDevelopment,
  airportPlaningAndDesign: getBusinessOpportunityDrillDownData.airportPlaningAndDesign,
  homePageBanner: getHomepageBannerDrillDownData.homePageBanner,
  smallcards: getspotlightSmallCardsDrillDownData.smallcards,
  largecards: getspotlightLargeCardsDrillDownData.largecards,
  commercialLeasingOpportunitiesList: getBusinessOpportunityDrillDownData.commercialLeasingOpportunitiesList,
  retailOutletList: getBusinessOpportunityDrillDownData.retailOutletList,
  othersList: getBusinessOpportunityDrillDownData.othersList,
  serviceOutletList: getBusinessOpportunityDrillDownData.serviceOutletList,
  foodAndBeverageList: getBusinessOpportunityDrillDownData.foodAndBeverageList,
  commercialLeasingOpportunitiesPageHeading:
    getBusinessOpportunityDrillDownData.commercialLeasingOpportunitiesPageHeading,
  publications: getPublicationsDrillDownData.publications,
  agencies: getAgenciesDrillDownData.agencies,
  airlineServicesFacilities: getBusinessOpportunityDrillDownData.airlineServicesFacilities,
  airlineServicesFacilitiesPageHeading: getBusinessOpportunityDrillDownData.airlineServicesFacilitiesPageHeading,
  calendarLegends: getOthersDrillDownData.calendarLegends,
  hyperLinkPopUp: getPopupDrillDownData.hyperLinkPopUp,
  mobileCalendarPage: getLoginDrillDownData.mobileCalendarPage,
  circular: getAnnouncementsDrillDownData.circular,
  general: getAnnouncementsDrillDownData.general,
  gallery: getGalleryDrillDownData.gallery,
  excellence: getContactDirectoryDrillDownData.excellence,
  addcontactdirectory: getContactDirectoryDrillDownData.addcontactdirectory,
  operation: getContactDirectoryDrillDownData.operation,
  CposOffice: getContactDirectoryDrillDownData.CposOffice,
  welcomeBanner: getPopupDrillDownData.welcomeBanner,
  webLoginPage: getLoginDrillDownData.webLoginPage,
  mainLoginPage: getLoginDrillDownData.mainLoginPage,
  vendorLoginPage: getLoginDrillDownData.vendorLoginPage,
  forgotPassword: getLoginDrillDownData.forgotPassword,
  signUp: getLoginDrillDownData.signUp,
  webBannerImages: getOthersDrillDownData.webBannerImages,
  mobileHomepageBannerSlider: getOthersDrillDownData.mobileHomepageBannerSlider,
  guestLoginFooterPage: getOthersDrillDownData.guestLoginFooterPage,
  vendorLoginFooterPage: getOthersDrillDownData.vendorLoginFooterPage,
  staffLoginFooterPage: getOthersDrillDownData.staffLoginFooterPage,
  subsidiariesPageHeading: getSubsidiariesHeadingDrillDownData.subsidiariesPageHeading,
  eramanRegistration: getEramanContentDrilldownData.eramanRegistration,
  eramanIcons: getEramanContentDrilldownData.eramanIcons,
  eramanSignIn: getEramanContentDrilldownData.eramanSignIn,
  eramanForgotPassword: getEramanContentDrilldownData.eramanForgotPassword,
  eramanOTP: getEramanContentDrilldownData.eramanOTP,
  epcMembership: getEramanContentDrilldownData.epcMembership,
  eramanUserProfile: getEramanContentDrilldownData.eramanUserProfile,
  eramanProductReview: getEramanContentDrilldownData.eramanProductReview,
  eramanResetPassword: getEramanContentDrilldownData.eramanResetPassword,
  epcRenewal: getEramanContentDrilldownData.epcRenewal,
  // adsBanner: getAdvertisementDrillDownData.adsBanner,
  bannerPromotion: getAdvertisementDrillDownData.bannerPromotion,
  bannerTopSelling: getAdvertisementDrillDownData.bannerTopSelling,
  bannnerBrands: getAdvertisementDrillDownData.bannnerBrands,
  bannerNews: getAdvertisementDrillDownData.bannerNews,
  homePageCarousel: getAdvertisementDrillDownData.homePageCarousel,
  campaign: getAdvertisementDrillDownData.campaign,
  socialMediaIcons: getFooterDrilldownData.socialMediaIcons,
  contactCentre: getFooterDrilldownData.contactCentre,
  copyrights: getFooterDrilldownData.copyrights,
  contents: getFooterDrilldownData.contents,
  menuHeader: getHeaderDrilldownData.menuHeader,
  topHeader: getHeaderDrilldownData.topHeader,
  categoryBanner: getHeaderDrilldownData.categoryBanner,
  eramanLogo: getFooterDrilldownData.eramanLogo,
  aboutEraman: getFooterDrilldownData.aboutEraman,
  eramanPrivilege: getFooterDrilldownData.eramanPrivilege,
  travellersInfo: getFooterDrilldownData.travellersInfo,
  singleCabinLuggagePolicyPageContent: getPagesTravellersInfoDrillDownData.singleCabinLuggagePolicyPageContent,
  singleCabinLuggagePolicyPageImage: getPagesTravellersInfoDrillDownData.singleCabinLuggagePolicyPageImage,
  guidelinesForCheckedinLuggagePageContent:
    getPagesTravellersInfoDrillDownData.guidelinesForCheckedinLuggagePageContent,
  guidelinesForCheckedinLuggagePageImage: getPagesTravellersInfoDrillDownData.guidelinesForCheckedinLuggagePageImage,
  lagsPageContent: getPagesTravellersInfoDrillDownData.lagsPageContent,
  lagsLiquidItemImage: getPagesTravellersInfoDrillDownData.lagsLiquidItemImage,
  restrictedItemsCheckedInCabinRestrictionsContent:
    getPagesTravellersInfoDrillDownData.restrictedItemsCheckedInCabinRestrictionsContent,
  restrictedItemsCheckedInCabinRestrictionsImage:
    getPagesTravellersInfoDrillDownData.restrictedItemsCheckedInCabinRestrictionsImage,
  restrictedItemsCabinOnlyRestrictionsContent:
    getPagesTravellersInfoDrillDownData.restrictedItemsCabinOnlyRestrictionsContent,
  restrictedItemsCabinOnlyRestrictionsImage:
    getPagesTravellersInfoDrillDownData.restrictedItemsCabinOnlyRestrictionsImage,
  lagsDisclaimerContent: getPagesTravellersInfoDrillDownData.lagsDisclaimerContent,
  lagsGuidelinesContent: getPagesTravellersInfoDrillDownData.lagsGuidelinesContent,
  latestNewsPageHeading: getMediaCentreDrillDownData.latestNewsPageHeading,
  archivesNewsPageHeading: getMediaCentreDrillDownData.archivesNewsPageHeading,
  airportLocations: getAirportLocationDrillDownData.airportLocations,
  parentAirport: getAirportLocationDrillDownData.parentAirport,
  childAirport: getAirportLocationDrillDownData.childAirport,
  mapPageHeading: getAirportLocationDrillDownData.mapPageHeading,
  sliders: getHomepageDrillDownData.sliders,
  youtube: getHomepageDrillDownData.youtube,
  travellerEssentialsOverview: getHomepageDrillDownData.travellerEssentialsOverview,
  travellerEssentialsList: getHomepageDrillDownData.travellerEssentialsList,
  usefulTipsPageList: getHomepageDrillDownData.usefulTipsPageList,
  usefulTipsPageContent: getHomepageDrillDownData.usefulTipsPageContent,
  cards: getHomepageDrillDownData.cards,
  pages: getHomepageDrillDownData.pages,
  appAbout: getMobileDrillDownData.appAbout,
  header: getMobileDrillDownData.header,
  highlight: getHomepageDrillDownData.highlight,
  appCardsListContent: getMobileDrillDownData.appCardsListContent,
  appCardsMainContent: getMobileDrillDownData.appCardsMainContent,
  appHeader: getMobileDrillDownData.appHeader,
  pageContent: getHelpDrillDownData.pageContent,
  footers: getFooterDrillDownData.footers,
  footerweb: getFooterDrillDownData.footerweb,
  grandchildheader: getHeaderpassDrillDownData.grandchildheader,
  childheaders: getHeaderpassDrillDownData.childheaders,
  mainheaders: getHeaderpassDrillDownData.mainheaders,
  cardheader: getHeaderpassDrillDownData.cardheader,
  FlightInfoHeaders: getFlightInfoDrillDownData.FlightInfoHeaders,
  pageContents: getFlightInfoDrillDownData.pageContents,

  pageHeading: getHelpDrillDownData.pageHeading,
  landingPageContent: getShopDineDrillDownData.landingPageContent,
  landingPageHeading: getShopDineDrillDownData.landingPageHeading,
  shopCategoriesPageHeading: getShopDineDrillDownData.shopCategoriesPageHeading,
  dineCategoriesPageHeading: getShopDineDrillDownData.dineCategoriesPageHeading,
  servicesCategoriesPageHeading: getShopDineDrillDownData.servicesCategoriesPageHeading,
  shopListPageHeading: getShopDineDrillDownData.shopListPageHeading,
  dineListPageHeading: getShopDineDrillDownData.dineListPageHeading,
  servicesListPageHeading: getShopDineDrillDownData.servicesListPageHeading,
  shopCategoriesPageContent: getShopDineDrillDownData.shopCategoriesPageContent,
  dineCategoriesPageContent: getShopDineDrillDownData.dineCategoriesPageContent,
  servicesCategoriesPageContent: getShopDineDrillDownData.servicesCategoriesPageContent,

  ourClientsMainContent: getOurClientsDrillDownData.ourClientsMainContent,
  localClients: getOurClientsDrillDownData.localClients,
  internationalClients: getOurClientsDrillDownData.internationalClients,
  boardOfDirectorsNextPage: getOrganisationDrillDownData.boardOfDirectorsNextPage,
  managementNextPage: getOrganisationDrillDownData.managementNextPage,
  milestoneOverview: getOurMilestonesDrillDownData.milestoneOverview,
  milestoneLinks: getOurMilestonesDrillDownData.milestoneLinks,
  servicePortals: getMainNavigationDrillDownData.servicePortals,
  socialMedia: getMainNavigationDrillDownData.socialMedia,
  aboutAndLegal: getMainNavigationDrillDownData.aboutAndLegal,
  zoneLevels: getShopDineDrillDownData.zoneLevels,
  zonePassenger: getShopDineDrillDownData.zonePassenger,
  zonePublic: getShopDineDrillDownData.zonePublic,
  shopListPageContent: getShopDineDrillDownData.shopListPageContent,
  dineListPageContent: getShopDineDrillDownData.dineListPageContent,
  shopAndDineLabelsData: getShopDineDrillDownData.shopAndDineLabelsData,
  servicesListPageContent: getShopDineDrillDownData.servicesListPageContent,
  //CENTERALIZED
  centralizedModules: getCentralizedModulesDrillDownData.centralizedModules,
  centralizedBanner: getCentralisedBannerDrillDownData.centralizedBanner,
  centralizedBannerTags: getCentralisedBannerDrillDownData.centralizedBannerTags,
  centralizedBannerType: getCentralisedBannerDrillDownData.centralizedBannerType,
  centralizedPromotions: getCentralisedPromotionsDrillDownData.centralizedPromotions,
  centralizedQandAs: getCentralizedFAQsDrillDownData.centralizedQandAs,
  centralizedFaqsCategories: getCentralizedFAQsDrillDownData.centralizedFaqsCategories,
  centralizedKeyInfoBanner: getCentralizedFAQsDrillDownData.centralizedKeyInfoBanner,
  centralizedAirlineTailImage: getCentralisedAirlineImagesDrillDownData.centralizedAirlineTailImage,
  privacyPolicyTabOne: getPrivacyPolicyDrillDownData.privacyPolicyTabOne,
  privacyPolicyTabTwo: getPrivacyPolicyDrillDownData.privacyPolicyTabTwo,
  myAirportsPrivacyPolicy: getPrivacyPolicyDrillDownData.myAirportsPrivacyPolicy,
  TabOneData: getPrivacyPolicyDrillDownData.TabOneData,
  TabTwoData: getPrivacyPolicyDrillDownData.TabTwoData,
  centralizedSingleCabinLuggagePolicyPageContent:
    getCentralizedTravellersInfoDrillDownData.centralizedSingleCabinLuggagePolicyPageContent,
  centralizedSingleCabinLuggagePolicyPageImage:
    getCentralizedTravellersInfoDrillDownData.centralizedSingleCabinLuggagePolicyPageImage,
  centralizedGuidelinesForCheckedinLuggagePageContent:
    getCentralizedTravellersInfoDrillDownData.centralizedGuidelinesForCheckedinLuggagePageContent,
  centralizedGuidelinesForCheckedinLuggagePageImage:
    getCentralizedTravellersInfoDrillDownData.centralizedGuidelinesForCheckedinLuggagePageImage,
  centralizedLagsLiquidItemImage: getCentralizedTravellersInfoDrillDownData.centralizedLagsLiquidItemImage,
  centralizedLagsPageContent: getCentralizedTravellersInfoDrillDownData.centralizedLagsPageContent,
  centralizedRestrictedItemsCheckedInCabinRestrictionsContent:
    getCentralizedTravellersInfoDrillDownData.centralizedRestrictedItemsCheckedInCabinRestrictionsContent,
  centralizedRestrictedItemsCheckedInCabinRestrictionsImage:
    getCentralizedTravellersInfoDrillDownData.centralizedRestrictedItemsCheckedInCabinRestrictionsImage,
  centralizedRestrictedItemsCabinOnlyRestrictionsContent:
    getCentralizedTravellersInfoDrillDownData.centralizedRestrictedItemsCabinOnlyRestrictionsContent,
  centralizedRestrictedItemsCabinOnlyRestrictionsImage:
    getCentralizedTravellersInfoDrillDownData.centralizedRestrictedItemsCabinOnlyRestrictionsImage,
  centralizedLagsDisclaimerContent: getCentralizedTravellersInfoDrillDownData.centralizedLagsDisclaimerContent,
  centralizedLagsGuidelinesContent: getCentralizedTravellersInfoDrillDownData.centralizedLagsGuidelinesContent,
  centralizedLagsSteps: getCentralizedTravellersInfoDrillDownData.centralizedLagsSteps,

  centralizedLandingPageContent: getCentralizedShopDineDrillDownData.centralizedLandingPageContent,
  centralizedLandingPageHeading: getCentralizedShopDineDrillDownData.centralizedLandingPageHeading,
  centralizedShopCategoriesPageHeading: getCentralizedShopDineDrillDownData.centralizedShopCategoriesPageHeading,
  centralizedDineCategoriesPageHeading: getCentralizedShopDineDrillDownData.centralizedDineCategoriesPageHeading,
  centralizedServicesCategoriesPageHeading:
    getCentralizedShopDineDrillDownData.centralizedServicesCategoriesPageHeading,
  centralizedShopListPageHeading: getCentralizedShopDineDrillDownData.centralizedShopListPageHeading,
  centralizedDineListPageHeading: getCentralizedShopDineDrillDownData.centralizedDineListPageHeading,
  centralizedServicesListPageHeading: getCentralizedShopDineDrillDownData.centralizedServicesListPageHeading,
  centralizedShopCategoriesPageContent: getCentralizedShopDineDrillDownData.centralizedShopCategoriesPageContent,
  centralizedDineCategoriesPageContent: getCentralizedShopDineDrillDownData.centralizedDineCategoriesPageContent,
  centralizedServicesCategoriesPageContent:
    getCentralizedShopDineDrillDownData.centralizedServicesCategoriesPageContent,
  centralizedShopListPageContent: getCentralizedShopDineDrillDownData.centralizedShopListPageContent,
  centralizedDineListPageContent: getCentralizedShopDineDrillDownData.centralizedDineListPageContent,
  centralizedServicesListPageContent: getCentralizedShopDineDrillDownData.centralizedServicesListPageContent,
  centralizedZoneLevels: getCentralizedShopDineDrillDownData.centralizedZoneLevels,
  centralizedZonePassenger: getCentralizedShopDineDrillDownData.centralizedZonePassenger,
  centralizedZonePublic: getCentralizedShopDineDrillDownData.centralizedZonePublic,

  centralizedBrands: getCentralizedShopDineDrillDownData.centralizedBrands,
  centralizedTags: getCentralizedShopDineDrillDownData.centralizedTags,
  centralizedType: getCentralizedShopDineDrillDownData.centralizedType,
  centralizedCategory: getCentralizedShopDineDrillDownData.centralizedCategory,
  centralizedSubCategory: getCentralizedShopDineDrillDownData.centralizedSubCategory,
  centralizedList: getCentralizedShopDineDrillDownData.centralizedList,
  centralizedDataClassification: getCentralizedShopDineDrillDownData.centralizedDataClassification,
  centralizedSource: getCentralizedShopDineDrillDownData.centralizedSource,
  centralizedLocation: getCentralizedShopDineDrillDownData.centralizedLocation,
  centralizedRedirectUrl: getCentralizedShopDineDrillDownData.centralizedRedirectUrl,

  notificationType: getMyAirportsPromotionsDrillDownData.notificationType,
  repeatType: getMyAirportsPromotionsDrillDownData.repeatType,
  promotion: getMyAirportsPromotionsDrillDownData.promotion,
  geoLocationPromotions: getMyAirportsPromotionsDrillDownData.geoLocationPromotions,
  geoLocationPromotionLevels: getMyAirportsPromotionsDrillDownData.geoLocationPromotionLevels,
  geoLocationOffer: getMyAirportsPromotionsDrillDownData.geoLocationOffer,
};
